import {
	KnowledgeCheckOptionID,
	KnowledgeCheckReviewQuestion,
} from '../knowledge-check'

/**
 * How a bar reads: with the correct answers on (`correct`, `wrong`), or
 * without them, when nothing may say which answer was right (`neutral`).
 */
export type AnswerTone = 'correct' | 'wrong' | 'neutral'

export type AnswerRow = {
	id: KnowledgeCheckOptionID
	answer: string
	/** Whole percent of the participants, 0 to 100. */
	percent: number
	/** The answer to mark as correct: only when the check reveals them. */
	marked: boolean
	tone: AnswerTone
}

/** The share of the participants that picked an answer, as a whole percent. */
export const answerShare = (
	numberOfSelected: number,
	countUsers: number
): number => {
	const percent = Math.round((100 * numberOfSelected) / countUsers)
	return Number.isFinite(percent) ? Math.min(100, Math.max(0, percent)) : 0
}

/** One row per answer of the question, as the review draws it. */
export const answerRows = (
	question: KnowledgeCheckReviewQuestion,
	countUsers: number,
	useCorrectAnswers: boolean
): AnswerRow[] =>
	question.options.map(option => ({
		id: option.id,
		answer: option.answer,
		percent: answerShare(option.numberOfSelected, countUsers),
		marked: useCorrectAnswers && option.correct,
		tone: !useCorrectAnswers ? 'neutral' : option.correct ? 'correct' : 'wrong',
	}))
